import React from "react";

import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from "reactstrap";

const InformationModal = ({
  onClose,
  title,
  body,
  rawBody = false,
  size = "md",
  closeButtonText = "Close",
  bodyClass = "",
}) => {
  const closeBtn = (
    <Button className="close" color="none" onClick={onClose}>
      &times;
    </Button>
  );

  return (
    <Modal isOpen={true} onClosed={onClose} size={size}>
      <ModalHeader close={closeBtn}>{title}</ModalHeader>
      <ModalBody className={bodyClass}>
        {rawBody ? (
          body
        ) : (
          <div dangerouslySetInnerHTML={{ __html: body }}></div>
        )}
      </ModalBody>
      <ModalFooter className="justify-content-between">
        <Button color={"secondary"} onClick={onClose}>
          {closeButtonText}
        </Button>{" "}
      </ModalFooter>
    </Modal>
  );
};

export default InformationModal;
